import { DELETE_EMPLOYEE, EMPLOYEE_PUBLISH, GET_EMPLOYEE, GET_EMPLOYEE_FIELD_VALUE, RESIGN_EMPLOYEE, GET_BRANCHES, GET_DEPARTMENTS, GET_DESIGNATIONS, GET_EMPLOYEE_CATEGORIES, GET_GENDERS, GET_SHIFTS } from './redux.actionTypes';

export const employeePublish = ({ handleComplete, ...payload }) => ({
    type: EMPLOYEE_PUBLISH,
    meta: { handleComplete },
    payload,
});

export const getEmployee = ({ handleSubmit, ...payload }) => ({
    type: GET_EMPLOYEE,
    meta: { handleSubmit },
    payload,
});

export const deleteEmployee = ({ handleSubmit, payload }) => ({
    type: DELETE_EMPLOYEE,
    meta: { handleSubmit },
    payload,
});

export const resignEmployee = ({ handleSubmit, payload }) => ({
    type: RESIGN_EMPLOYEE,
    meta: { handleSubmit },
    payload,
});

export const getEmployeeFieldValue = ({ handleSubmit, payload }) => ({
    type: GET_EMPLOYEE_FIELD_VALUE,
    meta: { handleSubmit },
    payload,
});

export const getBranches = ({ handleSubmit, payload }) => ({
    type: GET_BRANCHES,
    meta: { handleSubmit },
    payload,
});

export const getDepartments = ({ handleSubmit, payload }) => ({
    type: GET_DEPARTMENTS,
    meta: { handleSubmit },
    payload,
});

export const getDesignations = ({ handleSubmit, payload }) => ({
    type: GET_DESIGNATIONS,
    meta: { handleSubmit },
    payload,
});

export const getEmployeeCategories = ({ handleSubmit, payload }) => ({
    type: GET_EMPLOYEE_CATEGORIES,
    meta: { handleSubmit },
    payload,
});

export const getGenders = ({ handleSubmit, payload }) => ({
    type: GET_GENDERS,
    meta: { handleSubmit },
    payload,
});

export const getShifts = ({ handleSubmit, payload }) => ({
    type: GET_SHIFTS,
    meta: { handleSubmit },
    payload,
});